import EventEmitter from "eventemitter3";

import type {PartialLearningTimeInfo} from "@khan/analytics-learning-time";
import {updateLearningTimeInfo} from "@khan/analytics-learning-time/utils";

export class LearningTimeInfoApi {
    private readonly eventEmitter: EventEmitter;
    private _selfLti: PartialLearningTimeInfo;
    private _combinedLti: PartialLearningTimeInfo;
    private _previousLtiApi?: LearningTimeInfoApi;

    constructor(
        learningTimeInfo: PartialLearningTimeInfo,
        previousLtiApi?: LearningTimeInfoApi,
    ) {
        this.eventEmitter = new EventEmitter();
        this._previousLtiApi = previousLtiApi;
        this._selfLti = learningTimeInfo;
        this._combinedLti = {}; // updated by combinedLtis()

        this.combinedLtis();

        if (previousLtiApi) {
            previousLtiApi.on("change", () => {
                this.combinedLtis();
                this.eventEmitter.emit("change", this._combinedLti);
            });
        }
    }

    private combinedLtis() {
        this._combinedLti = this._previousLtiApi
            ? updateLearningTimeInfo(
                  this._previousLtiApi.combinedLti,
                  this._selfLti,
              )
            : this._selfLti;
    }

    public on(
        event: "change",
        listener: (lti: PartialLearningTimeInfo) => void,
    ) {
        this.eventEmitter.on(event, listener);
    }

    public update(learningTimeInfo: PartialLearningTimeInfo) {
        this._selfLti = learningTimeInfo;
        this.combinedLtis();
        this.eventEmitter.emit("change", this.combinedLti);
    }

    public get combinedLti() {
        return this._combinedLti;
    }
}
